/* Import some modules because typescript wont recognize my ambient declarations */
// @ts-ignore
import space_ from 'color-space'; // @ts-ignore

import DeltaE_ from 'delta-e';
export var colorSpace = space_;
export var DeltaE = DeltaE_;
/*====*/